//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "detail",
  data(){
    return {
      tabindex:1,
      kechengInfo:{},
      muluList:[],
      userList:{},
      isBuy:0,
      isExchange:0,
      notes:'',
      xcx:true
    }
  },
  methods:{
    getDetail(){
      this.axios.post('/xcx/Order/courseInfo',{course_id:this.$route.params.id}).then(res=>{
        this.kechengInfo=res.data.data.info;
        this.muluList=res.data.data.mulu;
        this.userList.num=res.data.data.count;
        this.userList.data=res.data.data.user.slice(0,5);
        this.isBuy=res.data.data.is_buy;
        this.isExchange=res.data.data.is_exchange;
        this.notes=res.data.data.info.notes.replace(/\n/g, "<br/>");
        this.$vux.loading.hide()
      })
    },
    smoothscroll(){
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.smoothscroll);
        window.scrollTo (0,currentScroll - (currentScroll/5));
      }
    },
    selectMulu(index){
      this.$set(this.muluList[index],'select',this.muluList[index].select?false:true);
    },
    toStudy(){
      location.href='/dist/#/HomeList?user_key='+this.$cookies.get('token')+'&id='+this.kechengInfo.id;
    },
    payhref(id,type){
      if(type=='tuangou'){
        location.href=`${location.protocol}//${location.host}/order/confirm?id=${id}&type=tuangou`;
      }else{
        location.href=`${location.protocol}//${location.host}/order/confirm?id=${id}`;
      }
      
    },
    gofree(id){
      location.href=`/dist/#/CatalogList?user_key=${this.$cookies.get('token')}&id=${id}`;
    },
    back(){
      let _this=this;
      this.$wechat.miniProgram.getEnv((res)=>{
      if(res.miniprogram){
        _this.$wechat.miniProgram.redirectTo({
          url:'/pages/index/index'
        });
      }else{
        _this.$router.push({name:'tutorial'});
      }
    })
    }
  },
  created() {
    this.$vux.loading.show()
      this.getDetail();
      if(window.__wxjs_environment==='miniprogram'){
        this.xcx=true;
      }else{
        this.xcx=false;
      }

      
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/detail.vue